import React from 'react';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ArtistPage from 'pages/ArtistPage';
import LoginPage from 'pages/LoginPage';
import FormsPage from 'pages/FormsPage';
import ArtistLanding from 'components/artists/ArtistLanding'
import WorkflowsPage from 'pages/WorkflowsPage';
import LandingPage from 'pages/LandingPage';
import UserHomePage from 'pages/UserHomePage';
import UserProfilePage from 'pages/UserProfilePage';
import AdminPage from 'pages/AdminPage';
import TeamsPage from 'pages/TeamsPage';
import OperationsPage from 'pages/OperationsPage';
import TeamsInviteAcceptPage from 'pages/TeamsInviteAcceptPage';
import NodePage from 'pages/NodePage';
import Project from 'components/projects/Project';
import BootstrapRoute from 'pages/BootstrapRoute';
import AuthenticatedShell from 'components/layout/AuthenticatedShell';

const router = createBrowserRouter([
  {path: "", element: <LandingPage />}, 
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/bootstrap",
    element: <BootstrapRoute />,
  },
  {
    path: "/home",
    element: (
      <AuthenticatedShell>
        <UserHomePage />
      </AuthenticatedShell>
    ),
  },
  {
    path: "/artist/:artistId",
    element: (
      <AuthenticatedShell>
        <ArtistPage />
      </AuthenticatedShell>
    ),
    children: [
      {index: true, element: <ArtistLanding />},
      { path: "team/forms", element: <FormsPage /> },
      //{ path: "queues", element: <TeamQueues /> },
      //{ path: "calendar", element: <TeamCalendar /> },
      { path: "team/workflows", element: <WorkflowsPage /> },
      { path: "team/", element: <TeamsPage /> },
      { 
        path: "operations", 
        element: <OperationsPage />,
        children: [
          { path: "workflows/:workflowId/nodes/:nodeId", element: <NodePage /> }
        ]
      },
        {path: "workflows/:workflowId/projects", element: <Project /> },
        {path: "workflows/:workflowId/projects/:projectId", element: <Project />}
    ],
  },
  {
    path: "/teams/:teamId/teaminvites/accept", 
    element: <TeamsInviteAcceptPage />,
  },
  {
    path: "/profile",
    element: (
      <AuthenticatedShell>
        <UserProfilePage />
      </AuthenticatedShell>
    ),
  },
  {
    path:"/userHomePage",
    element: (
      <AuthenticatedShell>
        <UserHomePage />
      </AuthenticatedShell>
    )
  },
  {
    path:"/admin", element: <AdminPage /> 
  }
]);

const App: React.FC = () => {
  return <RouterProvider router={router}/>;
}

export default App;
